const REACT_APP_ENV = process.env.REACT_APP_ENV;

if (REACT_APP_ENV !== 'development') {
  console.log = () => {};
}

const app_config = {
  development: {
    grecaptcha_key: '6LfrHtwsAAAAAKLI282gUWs9eiuWLo3KE91D-Ejz',
    fb_config_id: '927291376797716',
    fb_redirect_uri: 'http://localhost:3000/whatsapp',
    fl_key: 'FLWPUBK_TEST-78c22655d96a8004fd223ac90337bba3-X'
  },
  testing: {
    grecaptcha_key: '6LfrHtwsAAAAAKLI282gUWs9eiuWLo3KE91D-Ejz',
    fb_config_id: '927291376797716',
    fb_redirect_uri: 'https://app.gm-g6.xyz/whatsapp',
    fl_key: 'FLWPUBK-90e273cfab39d7a8b8cc6213411f1424-X'
  },
  staging: {
    grecaptcha_key: '6LfrHtwsAAAAAKLI282gUWs9eiuWLo3KE91D-Ejz',
    fb_config_id: '927291376797716',
    fb_redirect_uri: 'https://app.gm-g7.xyz/whatsapp',
    fl_key: 'FLWPUBK-90e273cfab39d7a8b8cc6213411f1424-X'
  },
  production: {
    grecaptcha_key: '6LfrHtwsAAAAAKLI282gUWs9eiuWLo3KE91D-Ejz',
    fb_config_id: '927291376797716',
    fb_redirect_uri: 'https://app.go-mailer.com/whatsapp',
    fl_key: 'FLWPUBK-90e273cfab39d7a8b8cc6213411f1424-X'
  }
};

export default app_config[REACT_APP_ENV];
